var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-content", staticStyle: { "padding-top": "100px" } },
      [
        _vm.loading
          ? _c("div", { attrs: { id: "loading" } }, [
              _c("div", { staticClass: "loadingMsg" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tab-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "fallback" }, [
                _c("p", { staticClass: "desc" }, [
                  _vm._v("自分のコンピューターからファイルを選択する ：")
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "btn-upload", attrs: { for: "file_excel" } },
                  [
                    _vm._v(
                      "\n              Excelファイルを選択\n              "
                    ),
                    _c("input", {
                      ref: "myFiles",
                      staticClass: "custom-file-input",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        id: "file_excel",
                        multiple: "",
                        accept: ".xlsx,xls"
                      },
                      on: { change: _vm.previewFiles }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "filename" }, [
                  _vm._v("選択されていません")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "error" }),
                _vm._v(" "),
                _c("div", { attrs: { id: "result" } }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "import_excel btn btn-info",
                    attrs: { type: "button", "data-toggle": "modal" },
                    on: {
                      click: function($event) {
                        _vm.importClick()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              登録データのアップロード\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "export_excel btn btn-info",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.exportClick()
                      }
                    }
                  },
                  [_vm._v("テンプレートのダウンロード")]
                )
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade custom-m",
        attrs: { id: "confirm-lowercase", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-green",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" }
                },
                [_vm._v("見直す")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-red",
                  staticStyle: { width: "250px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.yesChoiceLowerCase()
                    }
                  }
                },
                [_vm._v("小文字が含まれていても登録する")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("登録データのアップロード")
              ]),
              _vm._v(" "),
              _vm.exportProgress
                ? _c(
                    "div",
                    {
                      staticClass: "progress",
                      class: {
                        "progress-striped": !_vm.success,
                        active: !_vm.success
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "progress-bar",
                          style: _vm.progressWidth
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "progress-container" }, [
                _vm.importProgress
                  ? _c("div", { staticStyle: { "padding-top": "13px" } }, [
                      _vm.sheet1Name
                        ? _c("span", [_vm._v(_vm._s(_vm.sheet1Name) + "：")])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.importProgress
                  ? _c(
                      "div",
                      {
                        staticClass: "progress",
                        class: {
                          "progress-striped": !_vm.successSheet1,
                          active: !_vm.successSheet1
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "progress-bar",
                            style: _vm.progressWidthSheet1
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(Math.round(_vm.progressSheet1)) + "%"
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.successItemSheet1 > 0
                  ? _c("span", { staticClass: "success-label" }, [
                      _vm._v(
                        _vm._s(_vm.totalDataRowSheet1) +
                          "件中" +
                          _vm._s(_vm.successItemSheet1) +
                          "件をアップロードしました。"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "progress-container" }, [
                _vm.importProgress
                  ? _c("div", { staticStyle: { "padding-top": "13px" } }, [
                      _vm.sheet2Name
                        ? _c("span", [_vm._v(_vm._s(_vm.sheet2Name) + "：")])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.importProgress
                  ? _c(
                      "div",
                      {
                        staticClass: "progress",
                        class: {
                          "progress-striped": !_vm.success,
                          active: !_vm.success
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "progress-bar",
                            style: _vm.progressWidthSheet2
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(Math.round(_vm.progressSheet2)) + "%"
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.message.length !== 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #ccc",
                          color: "red",
                          "margin-top": "10px"
                        }
                      },
                      [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.message) }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.successItemSheet2 > 0
                  ? _c("span", { staticClass: "success-label" }, [
                      _vm._v(
                        _vm._s(_vm.totalDataRowSheet2) +
                          "件中" +
                          _vm._s(_vm.successItemSheet2) +
                          "件をアップロードしました。"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "question", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-success",
                  attrs: { id: "yes-choice", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.yesChoice()
                    }
                  }
                },
                [_vm._v("送信する")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  attrs: { id: "no-choice", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.noChoice()
                    }
                  }
                },
                [_vm._v("送信しない")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("ユーザー一括登録")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("ユーザー一括登録")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-info" }, [
      _vm._v(
        "\n            ユーザーの登録と個人コードとゲートグループの紐づけをExcelファイルを使用して、一括で実施することができます。"
      ),
      _c("br"),
      _vm._v(
        "\n            登録するために必要なテンプレートExcelファイルは、”テンプレートのダウンロード”から取得して下さい。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [
        _vm._v(
          "ユーザーの登録と個人コードとゲートグループの紐づけを一括で登録するテンプレートファイルをダウンロードできます。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", [_vm._v("＜本ファイルで設定可能なデーター＞")]),
      _vm._v(" "),
      _c("p", [_vm._v("ユーザーの登録")]),
      _vm._v(" "),
      _c("p", [_vm._v("ユーザーとカード（個人コード）の紐づけ")]),
      _vm._v(" "),
      _c("p", [_vm._v("ユーザーとゲートグループの紐づけ")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", [_vm._v("＜SMS認証サービス加入者のみ設定可能なデーター＞")]),
      _vm._v(" "),
      _c("p", [_vm._v("SMS認証の設定")]),
      _vm._v(" "),
      _c("p", [_vm._v("携帯電話番号の登録")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", [_vm._v("ダウンロード前に以下の設定を行って下さい。")]),
      _vm._v(" "),
      _c("p", [_vm._v(" ・ゲートの設定")]),
      _vm._v(" "),
      _c("p", [_vm._v(" ・ゲートグループの作成")]),
      _vm._v(" "),
      _c("p", [_vm._v(" ・ゲートグループへの紐付け")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("個人コード登録")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", [
        _vm._v(
          "\n            カード番号に半角英字の小文字が含まれております。"
        ),
        _c("br"),
        _vm._v(
          "\n            小文字が含まれているとカードが正常に読み込まれません。"
        ),
        _c("br"),
        _vm._v(
          "\n            小文字が含まれているかを確認してください。\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "padding-top": "13px" } }, [
      _c("span", { staticClass: "error-box-title" }, [
        _vm._v("アップロード失敗")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", [
        _vm._v(
          "\n            作成したユーザーのメールアドレスへ通知メールを送信しますか？\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e85d0b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e85d0b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-register/UserRegister.vue
// module id = null
// module chunks = 